import { request } from './core'
import type { AssistantContext, AssistantResponse } from './types'

/** "Chat with company" — send a message under a module context (background
 *  agent reply, poll the GET), and accept/reject the changes the agent
 *  proposed. Every mutation is optimistic-locked against the COMPANY revision
 *  (If-Match): the send snapshots the state the agent reasons over, and
 *  apply/dismiss overwrite content. */
export const assistantApi = {
  getAssistant: (slug: string) =>
    request<AssistantResponse>(`/api/companies/${slug}/assistant`),

  sendAssistantMessage: (
    slug: string,
    message: string,
    context: AssistantContext,
    revision?: number,
  ) =>
    request<{ status: string; revision: number }>(
      `/api/companies/${slug}/assistant/messages`,
      { method: 'POST', body: JSON.stringify({ message, context }) },
      { ifMatch: revision },
    ),

  applyAssistantChanges: (slug: string, changeIds: string[], revision?: number) =>
    request<{ applied: string[]; errors: Record<string, string>; remaining: number; revision: number }>(
      `/api/companies/${slug}/assistant/changes/apply`,
      { method: 'POST', body: JSON.stringify({ change_ids: changeIds }) },
      { ifMatch: revision },
    ),

  dismissAssistantChanges: (slug: string, changeIds: string[], revision?: number) =>
    request<{ remaining: number; revision: number }>(
      `/api/companies/${slug}/assistant/changes/dismiss`,
      { method: 'POST', body: JSON.stringify({ change_ids: changeIds }) },
      { ifMatch: revision },
    ),
}
